module.exports = __webpack_public_path__ + "img/luminescence1.4cadba37.png";